import React, { useContext } from 'react';
import { Tr, Td } from '@chakra-ui/react';
import { optionalValue } from '../../../services/text/optionalValue';
import { getMaxRole, getRoleFromOption } from '../../../services/roles';
import { ActiveUsersTableContext } from '../../pages/upgrade/TeamManagement/ActiveUsersTableContext';
import { RenderIf } from '../RenderIf/RenderIf';
const UsersTableRow = ({ user, children }) => {
    const jobTitle = user.roles
        ? getMaxRole(user.roles.map(({ id }) => id))?.name
        : undefined;
    const { canPerformActions } = useContext(ActiveUsersTableContext);
    const permissions = user.roles
        ?.map((role) => getRoleFromOption(role.id).name)
        .join(', ');
    return (React.createElement(Tr, { "data-testid": "users_table_row_row" },
        React.createElement(RenderIf, { condition: canPerformActions },
            React.createElement(Td, null, children)),
        React.createElement(Td, { "data-testid": "users_table_row__full_name" }, user.full_name),
        React.createElement(Td, { "data-testid": "users_table_row__email" }, user.email),
        React.createElement(Td, { "data-testid": "users_table_row__job_title" }, optionalValue(jobTitle)),
        React.createElement(Td, { "data-testid": "users_table_row__permissions" }, optionalValue(permissions))));
};
export default UsersTableRow;
